import { render, staticRenderFns } from "./CheckpointForm.vue?vue&type=template&id=21db52c8"
import script from "./CheckpointForm.vue?vue&type=script&lang=js"
export * from "./CheckpointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports